import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import merge from 'lodash/merge';
import Featured from 'marketing/common/featured';
import ReviewsAgg from 'marketing/containers/reviews_agg';
import Image from 'common/components/image';

const PrevButton = ({ onClick }) => (
  <i className="fa fa-angle-left btn-prev" onClick={onClick} />
);

const NextButton = ({ onClick }) => (
  <i className="fa fa-angle-right btn-next" onClick={onClick} />
);

const SETTINGS = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: <PrevButton />,
  nextArrow: <NextButton />
};

const DEFAULT_TESTIMONIALS = [
  {
    image: 'https://assets.crowdspring.com/marketing/crowdspring_marketing_testimonial_cori-newlander.jpg',
    title: 'I can\'t speak highly enough of crowdspring.',
    quote: 'I started with a small budget and some boring content, and within a short time, I had some amazing designs to choose from. The hardest part was choosing one!',
    author: 'Cori Newlander, City of Santa Monica',
  },
  {
    image: 'https://assets.crowdspring.com/marketing/crowdspring_marketing_testimonial_christina-catalano.jpg',
    title: 'I am thrilled with the professional and eye-catching final design!',
    quote: 'I had over 100 entries that were creative, unique, and specific to my design ideas. I would asbsolutely recommend crowdspring to any professional who doesn’t have an in-office creative team.',
    author: 'Christina Catalano, Catalano & Associates',
  },
  {
    image: 'https://assets.crowdspring.com/marketing/crowdspring_marketing_testimonial_jeff-knowles.jpg',
    title: 'Crowdspring will be my first stop for my future creative needs.',
    quote: 'I’ve had great success with crowdspring, using the website to both redesign an existing website and to create a website from scratch. Both projects produced a large number of high quality design options.',
    author: 'Jeff Knowles',
  },
];

const Testimonials = ({ items = DEFAULT_TESTIMONIALS, featured, title }) => (
  <section className="block block-testimonial">
    <div className="row columns">
      <div className="block-header">
        <ReviewsAgg title={title} />
      </div>
    </div>
    <div className="slider-container">
      <div className="row">
        <div className="small-16 medium-12 medium-offset-2 large-10 large-offset-3 columns">
          <Slider {...merge({}, SETTINGS, { nextArrow: <NextButton />, prevArrow: <PrevButton /> })}>
            {items.map((item, i) => (
              <div className="testimonial" key={i}>
                <div className="quote">
                  <h3>&quot;{item.title}&quot;</h3>
                  <p className="show-for-medium">{item.quote}</p>
                </div>
                <Image
                  alt={item.author}
                  src={item.image}
                  className="avatar avatar-round avatar-testimonial"
                />
                <div className="testimonial-meta">
                  {item.author}
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
    {featured &&
      <Featured />
    }
  </section>
);

export default Testimonials;
